/*
import React from "react";
import EventReviewDisplayResume from "../utils/EventReviewDisplayResume";
import EventReviewForm from "../utils/EventReviewForm";

function Feedback() {

  const reviews = [
    {title: 'prova 1', name: 'user 1', comment: 'comment 1'},
    {title: 'prova 2', name: 'user 2', comment: 'comment 2'},
    {title: 'prova 3', name: 'user 3', comment: 'comment 3'},
  ]

  return (
    <>
      <div style={{ width: "100%", display: "row", color: "#2C2C2C" }}>
        <div>
          <EventReviewForm></EventReviewForm>
        </div>
        <div>
          <EventReviewDisplayResume
            reviews = {reviews}
          ></EventReviewDisplayResume>
        </div>
      </div>
    </>
  );
}

export default Feedback;
*/

import React, { useEffect, useState } from "react";
import EventReviewDisplayResume from "../utils/EventReviewDisplayResume";
import EventReviewForm from "../utils/EventReviewForm";
import "./Feedback.css"; // Importa il file CSS
import axios from "axios";
import serverConfig from "../config";

import toast, { Toaster } from "react-hot-toast";
import SecondaryMenu from "../SecondaryMenu";

function Feedback() {
  const [feedback, setFeedback] = useState([]);

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_feedbacks`)
      .then((response) => {
        const data = response.data;
        setFeedback(data);
      })
      .catch((error) => {
        //alert("ERRORE | get_feedbacks");
        //console.log("ERRORE | get_feedbacks", error);
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const componentsFeedback = (
    <>
      <div className="feedback-container-principal">
        <div className="feedback-container">
          <div className="feedback-form">
            <EventReviewForm />
          </div>
          <div className="feedback-reviews">
            <EventReviewDisplayResume reviews={feedback} />
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      {/*}
    <div className="feedback-container-principal">
      <div className="feedback-container">
        <div className="feedback-form">
          <EventReviewForm />
        </div>
        <div className="feedback-reviews">
          <EventReviewDisplayResume reviews={feedback} />
        </div>
      </div>
    </div>
*/}

      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        <div className={`main-content col-12`}>{componentsFeedback}</div>
        {/*
        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>{componentsFeedback}</div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {componentsFeedback}
            </div>
          </>
        )}
          */}
      </div>
    </>
  );
}

export default Feedback;
